import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';


import { NgbActiveModal, NgbDateStruct, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService, DateUtils } from 'ng-jhipster';

import { Invoice, InvoiceStatus } from './invoice.model';
import { InvoicePopupService } from './invoice-popup.service';
import { InvoiceService } from './invoice.service';
import { Payment, PaymentUtilService, PaymentService } from '../payment';
import { PaymentItem, PaymentItemService } from '../payment-item';
import { Student } from '../student';
import { School, SchoolService } from '../school';
import { Tax, TaxService } from '../tax';
import { Country, CountryService } from '../country';
import { City, CityService } from '../city';


import { AbstractGeograpicalDialogComponent } from '../abstract-dialog-component/abstract-geopraphical-dialog.component';
import { Principal, CRUD_ACTIONS, DateUtilities } from '../../shared/index';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BlobUtilities } from '../../shared/blob/blob-utils';

@Component({
    selector: 'jhi-invoice-request-dialog',
    templateUrl: './invoice-request-dialog.component.html'
})
export class InvoiceRequestDialogComponent  extends AbstractGeograpicalDialogComponent implements OnInit {

    invoice: Invoice;
    authorities: any[];
    isSaving: boolean;
    pdfUrl: SafeResourceUrl | null = null;
    toggleShowPdf: boolean = false;  // Initially hide the PDF;
    protected taxes: Tax[];
    protected loadingTaxes: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private invoiceService: InvoiceService,
        private paymentService: PaymentService,
        countryService: CountryService,
        cityService: CityService,
        taxService: TaxService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        private router: Router,
        principal: Principal,
        private sanitizer: DomSanitizer
    ) {
        super(countryService, cityService, taxService, schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['payment', 'paymentType', 'paymentItem', 'invoice', 'invoiceStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.loadSchools();
        this.schoolService.findCurrent()
                              .subscribe(school => {
                                this.currentSchool = school;
                                this.loadTaxes(this.currentSchool.countryId);
                              }, e => this.onError(e));

        this.loadGeographicalLocations(this.invoice.billingCountryId);
    }

    private loadTaxes(countryId: number) {
        this.taxService
            .query().subscribe(
            (res: HttpResponse<Tax[]>) => {
                this.taxes = res.body;
                this.loadingTaxes = false;
                if (this.taxes) {
                    let countryTaxes = this.taxes.filter(tax => tax.country.id === countryId);
                    this.taxes = countryTaxes.sort((a: Tax, b: Tax) =>
                                a && a.code.localeCompare(b.code));

                    // preselect the tax
                    if (this.invoice.school && this.invoice.school.defaultTaxId && this.taxes.length > 0) {
                        const defaultTax = this.taxes.find(tax => tax.id === this.invoice.school.defaultTaxId);
                        if (defaultTax) {
                            this.invoice.taxRate = defaultTax.rate; // Preselect the tax rate
                        }
                    }
                }
            },
            (res: HttpErrorResponse) => this.onError(res));

    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    saveInvoice(form: NgForm) {
        if (this.invoice.id !== undefined && this.invoice.id !== null) {
            this.invoiceService.updateByStudent(this.invoice)
                .subscribe((res: Invoice) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.invoiceService.createByStudent(this.invoice)
                .subscribe((res: Payment) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    onBillingCountryChange(countryId: number, form: NgForm): void {
        // call the parent's logic first
        super.onCountryChange(countryId, form, true, false);

        // custom logic to populate the country
        let selected = this.countries.find(c => c.id === countryId);
        if (selected) {
            this.invoice.billingCountry = selected.name;
        }
    }

    onCityChange(cityId: number, form: NgForm): void {
        let selected = this.cities.find(c => c.id === cityId);
        if (selected) {
            this.invoice.billingCity = selected.name;
        }
    }

    private onSaveSuccess(result: Invoice, action: String) {
        this.eventManager.broadcast({ name: 'invoiceListModification', content: {
            action: action,
            content: result
        }});

        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-invoice-popup',
    template: ''
})
export class InvoiceRequestPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private invoicePopupService: InvoicePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.invoicePopupService
                    .open(InvoiceRequestDialogComponent as Component, params['id']);
            }  else if (params['paymentId']) {
                this.modalRef = this.invoicePopupService
                    .open(InvoiceRequestDialogComponent as Component, null, params['paymentId']);
            } else {
                this.modalRef = this.invoicePopupService
                    .open(InvoiceRequestDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice-request-dialog.component.ts